import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useGetTaskLabels = function useGetTaskLabels(workspaceId) {
  return useQuery(["task-labels", workspaceId], function () {
    return servicesUtils.getService("/workspaces/".concat(workspaceId, "/reminder/labels/"));
  }, {
    enabled: !!workspaceId
  });
};
export default useGetTaskLabels;